import script from "./UserInforClient.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInforClient.vue?vue&type=script&lang=ts&setup=true"

import "./UserInforClient.vue?vue&type=style&index=0&id=003613e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003613e4"]])

export default __exports__